<template>
  <CSectionCard v-if="items.length > 0" :title="job.description.content.toUpperCase()">
    <template #header>
      <CLinkJobDropdown :source="job" :targets="otherJobs" :context/>
    </template>

    <template #default>
      <CRepairOrderItem v-for="item in items" :item :job :context/>
    </template>
  </CSectionCard>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CSectionCard from '@/shared/components/section/CSectionCard.vue';
  import Job from '../../models/Job';
  import JobContext from '../../models/JobContext';
  import CLinkJobDropdown from './CLinkJobDropdown.vue';
  import CRepairOrderItem from './CRepairOrderItem.vue';

  const props = defineProps<{
    job: Job;
    context: JobContext;
  }>();

  const otherJobs = computed(() => props.context.jobs.filter(job => job !== props.job));

  const items = computed(() => props.context.items.filter(i => i.jobId === props.job.id && !i.deletedOn));
</script>